<template>
  <div>
    <div>
      <el-form @submit.native.prevent v-show="isShowForm" :inline="true" :model="param" ref="form1">
        <el-form-item label="内容" prop="key" :rules="[{ required: true, message: '内容不能为空'}]">
          <el-input v-model="param.key" show-password placeholder="请输入内容" clearable @keyup.enter.native="list"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
      </el-form>
      <el-form v-show="!isShowForm" :inline="true" ref="form2">
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div align="center">
      <el-table :data="tableData" ref="dataTable" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="name" label="权限名称" width="180" />
        <el-table-column prop="privilege" label="权限值" width="150" show-overflow-tooltip/>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="handleSet(scope.row)" size="small">修改</el-button>
            <el-button type="text" icon="el-icon-edit" @click="handleDel(scope.row)" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
        <el-form ref="form" :model="form" label-width="120px">
          <el-row>
            <el-col :span="20">
              <el-form-item label="权限名称" prop="name" :rules="[{required: true, message: '权限名称为空'}]">
                <el-input v-model="form.name" maxlength="50" style="width: 280px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="权限值" prop="privilege" :rules="[{required: true, message: '权限值为空'}]">
                <el-input type="number" v-model="form.privilege" maxlength="200" style="width: 280px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel('form')">取消</el-button>
          <el-button type="primary" v-if="dialogStatus==='add'" @click="add('form')"><span>确定</span></el-button>
          <el-button type="primary" v-if="dialogStatus==='set'" @click="set('form')"><span>确定</span></el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as http from '../api/http'
import * as util from '../util/util'

export default {
  name: 'ZtPrivilege',
  data () {
    return {
      dialogStatus: '',
      dialogTitle: '',
      dialogVisible: false,
      isShowForm: true,
      param: {key: null},
      tableData: [],
      form: {}
    }
  },
  created () {
    // this.list()
  },
  methods: {
    cancel () {
      this.dialogVisible = false
    },
    add (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.key = this.param.key
        http.post(global.url0 + 'zt_privilege/add/', this.form).then(
          res => {
            if (res === 200) {
              this.dialogVisible = false
              this.$message.success('新增成功')
              this.list()
            } else {
              this.$message.error('新增失败:' + res)
            }
          }
        )
      })
    },
    set (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.key = this.param.key
        http.post(global.url0 + 'zt_privilege/set/', this.form).then(
          res => {
            if (res === 200) {
              this.dialogVisible = false
              this.$message.success('修改成功')
              this.list()
            } else {
              this.$message.error('修改失败:' + res)
            }
          }
        ).catch(
          msg => {
            this.$message.error('修改异常:' + msg)
          }
        )
      })
    },
    handleAdd () {
      this.form = {}
      this.dialogStatus = 'add'
      this.dialogTitle = '新增'
      this.dialogVisible = true
    },
    handleSet (row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogStatus = 'set'
      this.dialogTitle = '修改'
      this.dialogVisible = true
    },
    handleDel (row) {
      this.$confirm('此操作将永久删除记录，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form = {}
        this.form.key = this.param.key
        this.form.id = row.id
        http.post(global.url0 + 'zt_privilege/del/', this.form).then(
          res => {
            if (res === 200) {
              this.$message.success('删除成功')
              this.list()
            } else {
              this.$message.error('删除失败')
            }
          }
        )
      })
    },
    list () {
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.tableData = []
          if (this.param.key === null || this.param.key.length <= 0) {
            alert('请输入内容')
            return
          }
          http.post(global.url0 + 'zt_privilege/get/', this.param).then(
            res => {
              if (res.length > 0 && !String.startsWith(res, '[')) {
                alert('请输入正解的内容！')
                return
              }
              // console.log(res)
              this.isShowForm = false
              // this.param.key = null
              this.tableData = res
            }
          )
        }
      })
    },
    handleExport () {
      util.toExcel(this.$refs.dataTable.columns, this.tableData, 'ZtPrivilege')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/ZtPrivilege.vue